import { render, staticRenderFns } from "./Restore.vue?vue&type=template&id=b5a2003a&scoped=true&"
import script from "./Restore.vue?vue&type=script&lang=js&"
export * from "./Restore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a2003a",
  null
  
)

export default component.exports